import { type UseQueryResult, useQuery } from 'react-query';
import {
  PoolService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_Common_IntDropdownWithSystemNameDto,
} from '@wealthlane/api-services/wealthlane-award-service';
import { type OptionType } from '../../types/common';

const useGetPoolTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<OptionType[] | undefined, unknown> => {
  const poolTypes = useQuery(['getPoolTypes'], async () => {
    const data = await handleRequest(PoolService.getApiAwardApiAppPoolPoolTypes());
    return data?.map(
      (
        // eslint-disable-next-line camelcase
        item: Wealthlane_AwardService_Dtos_Common_IntDropdownWithSystemNameDto
      ) => ({
        label: item.displayName,
        value: item.id,
        systemName: item.systemName,
      })
    );
  });

  return poolTypes;
};

export default useGetPoolTypes;
